export enum ScheduledPaymentDurationEnum {
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  HALF_YEAR = 'HALF_YEAR',
  YEAR = 'YEAR',
  UNLIMITED = 'UNLIMITED',
  CUSTOM = 'CUSTOM',
  SINGLE = 'SINGLE'
}
